/* eslint no-unused-vars: 0 */
import { urlPath } from "../components/Settings";

let authHeader = {};
let checkPermissionCache = {};
let hasPermissionCache = {};
let hasPermissionsCache = {};
let userId;
let userInternal = false;
let userName = '';

export function setAuthHeader(header) {
	console.log("Setting 'Authorization' header", header);
	authHeader = header;
}

export function getAuthHeader() {
	return authHeader;
}

export function setUser(user) {
	userId = user.id;
	userName = user.name;
	userInternal = user.rol_enum !== "CLIENT";
}

export function getUserName() {
	return userName;
}

function fetchStatus(response) {
	return response.ok? Promise.resolve(response.text()): Promise.reject(new Error(response.statusText));
}

function fetchStatusJson(response) {
	return response.ok? Promise.resolve(response.json()): Promise.reject(new Error(response.statusText));
}

export function checkPermission(keys, callback) {
	if (checkPermissionCache[keys])
		callback(checkPermissionCache[keys]);
	else if (userId)
		fetch(urlPath + "/api/noauth/haspermissions?key=" + keys + "&userid=" + userId)
			.then(fetchStatusJson)
			.then(json => {
				checkPermissionCache[keys] = json;
				callback(json);
			}).catch(e => {
				console.error("Cannot retrieve permissions " + keys, e);
				callback(null);
			});
	else
		fetch(urlPath + "/api/haspermissions?key=" + keys, {credentials: 'include', headers: authHeader})
			.then(fetchStatusJson)
			.then(json => {
				checkPermissionCache[keys] = json;
				callback(json);
			}).catch(e => {
				console.error("Cannot retrieve permissions " + keys, e);
				callback(null);
			});
}

export function hasPermission(key, status, callback) {
	if (hasPermissionCache[key] && typeof hasPermissionCache[key][status] !== 'undefined')
		callback(hasPermissionCache[key][status]);
	else if (userId)
		fetch(urlPath + "/api/noauth/haspermission?key=" + key + "&status=" + status + "&userid=" + userId)
			.then(fetchStatus)
			.then(text => {
				const v = text === 'true';
				hasPermissionCache[key] = hasPermissionCache[key] || {};
				hasPermissionCache[key][status] = v;
				callback(v);
			}).catch(e => {
			console.error("Cannot retrieve permission " + key + ":" + status, e);
			callback(null);
		});
	else
		fetch(urlPath + "/api/haspermission?key=" + key + "&status=" + status, {credentials: 'same-origin'})
			.then(fetchStatus)
			.then(text => {
				const v = text === 'true';
				hasPermissionCache[key] = hasPermissionCache[key] || {};
				hasPermissionCache[key][status] = v;
				callback(v);
			}).catch(e => {
			console.error("Cannot retrieve permission " + key + ":" + status, e);
			callback(null);
		});
}

export function hasPermissions(keys, status, callback, userParamId) {
	if (hasPermissionsCache[keys] && typeof hasPermissionsCache[keys][status] !== 'undefined')
		callback(hasPermissionsCache[keys][status]);
	else if (userId || userParamId)
		fetch(urlPath + "/api/noauth/haspermissions?key=" + keys + "&status=" + status + "&userid=" + (userId || userParamId))
			.then(fetchStatusJson)
			.then(json => {
				hasPermissionsCache[keys] = hasPermissionsCache[keys] || {};
				hasPermissionsCache[keys][status] = json;
				callback(json);
			}).catch(e => {
				console.error("Cannot retrieve permissions " + keys + ":" + status, e);
				callback(null);
			});
	else
		fetch(urlPath + "/api/haspermissions?key=" + keys + "&status=" + status, {credentials: 'same-origin'})
			.then(fetchStatusJson)
			.then(json => {
				hasPermissionsCache[keys] = hasPermissionsCache[keys] || {};
				hasPermissionsCache[keys][status] = json;
				callback(json);
			}).catch(e => {
				console.error("Cannot retrieve permissions " + keys + ":" + status, e);
				callback(null);
			});
}

export function handleErrors(response) {
	if (!response.ok)
		throw Error(response.statusText);
	return response;
}



// WEBPACK FOOTER //
// ./src/utils/security.js